<template>
	<div class="unavailable">
		<div class="ui icon header">
			<i class="huge ban icon"></i>
			<div class="content">
				{{ i18n('Validation.UnavailableReport')}}
			</div>
		</div>
	</div>
</template>

<script>
  import {i18nMixin} from '@/modules/neodash/mixins';

  export default {
    mixins: [i18nMixin]
  };
</script>

<style lang="scss" scoped>
	.unavailable {
		background-color: #ffffff;
		position: absolute;
		overflow: hidden;
		margin: 1rem;
		border: 1px solid #ccc;
		border-radius: 4px;
		bottom: 50px;
		box-shadow: inset 0 1px 0 hsla(0, 0%, 100%, .2), 0 1px 2px rgba(0, 0, 0, .05) !important;
		top: 50px;
		left: 0;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: center;

		.ui.header {
			color: #bdbdbd;

			.icon {
				color: #e0e0e0;
			}
		}
	}
</style>
